import { Component, OnInit, Input, Output } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';

import { AuthenticationService } from '../../services/core/authentication.service';
import { ConfigService } from '../../services/core/config.service';
import { AppService } from '../../services/app.service';

import { ApiConnectionService } from '../../services/core/api-connection.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'app-modal-register',
	templateUrl: './modal-register.component.html',
	styleUrls: ['./modal-register.component.scss']
})
export class ModalRegisterComponent implements OnInit {
	@Input() public message;
	@Output() passEntry: EventEmitter<any> = new EventEmitter();

	sections: any = [];
	organisationName = "";
	classroomName = "";
	name = "";
	password = "";
	repeatPassword = "";
	currentUser;
	email = "";

	classroomCode = "";
	classroomCode1 = "";
	classroomCode2 = "";
	classroomCode3 = "";
	classroomCode4 = "";
	classroomCode5 = "";
	classroomCode6 = "";
	classroomCode7 = "";
	classroomCode8 = "";

	apiUrl = '';

	step: any = 0;
	errors: any = [];
	errormessage: any = false;

	successmessage = false;
	changepassword = false;

	emailValid = false;
	passwordValid = false;
	errorEmailRequired = false;
	errorInvalidEmail = false;
	errorInvalidEmailTld = false;
	errorPasswordRequired = false;
	errorInvalidPassword = false;
	repeatPasswordValid = false;
	repeatPasswordInvalid = false;
	error = false;
	registerHash = '';

	urlParameters = {};

	cdnUrl = '';
	frontUrl = '';
	systemTitle = '';
	allowedTld: any;

	constructor(
		public activeModal: NgbActiveModal,
		public appService: AppService,
		public dom: DomSanitizer,
		public api: ApiConnectionService,
		public authenticationService: AuthenticationService,
		private configService: ConfigService,
		private ngxLoader: NgxUiLoaderService
	) {
		let self = this;

		this.apiUrl = configService.get('api_url');
		this.frontUrl = configService.get('frontUrl');
		this.cdnUrl = configService.get('cdn_url');
		this.systemTitle = configService.get('title');
		this.allowedTld = configService.get('registration_allowed_extension');

		self.authenticationService.data.subscribe(data => {
			if (Object.keys(data).length) {
				self.currentUser = data;
			} else {
				self.currentUser = false;
			}
		});
		self.appService.setDefaultAuthor();
		this.appService.setShowCheckRequestAlert();
	}

	async checkHashArguments() {
		try {
			let search = location.hash.substring(1);
			let params = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');

			this.urlParameters = params;

			if (this.urlParameters['externalHash'] != undefined) {
				this.registerHash = this.urlParameters['externalHash'];
				this.checkStep0();
			}
		} catch (e) {

		}
	}

	ngOnInit(): void {
		this.appService.navActive();
		let self = this;
		this.ngxLoader.start();

		self.authenticationService.getCurrentUser().then(function (response) {
			self.ngxLoader.stop();
		});

		try {
			let search = location.hash.substring(1);
			let params = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');

			this.classroomCode = params['code'];
		} catch (e) {

		}

		this.checkHashArguments();
	}

	next() {

	}

	checkStep0() {
		this.step = 1;
	}

	checkStep1() {
		let self = this;
		self.errormessage = false;
		this.ngxLoader.start();
		self.api.read('users/checkClassroomCode/' + self.classroomCode + '').then(function (response) {
			self.classroomName = response['name'];
			self.organisationName = response['organisationName'];

			if(self.registerHash == '') {
				self.step = 2;
			} else {
				self.password = 'nopassword';
				self.repeatPassword = 'nopassword';
				self.step = 2;
			}


			self.ngxLoader.stop();
		}).catch(function (response) {
			self.ngxLoader.stop();
			if (response['error']['code'] === 'CODE_NOT_FOUND') {
				self.errormessage = "Deze klascode bestaat niet.";
			} else {
				self.errormessage = "Er is een fout opgetreden";
			}
		});
	}

	checkPassword(event) {
		if (this.password.length < 4) {
			this.passwordValid = false;
			this.errorPasswordRequired = true;
		} else {
			this.passwordValid = true;
			this.errorPasswordRequired = false;
		}
	}

	validateTld(email) {
		let emailPieces = email.split('.');
		let tld = emailPieces.pop();
		tld = tld.toLowerCase();

		let tldAllowed = false;
		for (let x = 0; x < this.allowedTld.length; x++) {
			if (this.allowedTld[x] == tld) {
				tldAllowed = true;
			}
		}

		return tldAllowed;
	}

	validateEmail(email) {
		const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}

	toStep1() {
		this.step = 1;
	}

	toStep2() {
		this.step = 2;
	}

	toStep3() {
		if (this.registerHash == '') {
			this.step = 3;
		} else {
			this.step = 2;
		}
	}

	checkStep2() {
		let self = this;
		self.errormessage = false;

		this.ngxLoader.start();

		let email = btoa(self.email);

		self.api.read('users/checkEmail/' + email + '&type=base64').then(function (response) {
			if (self.registerHash != '') {
				self.password = 'nopassword';
				self.repeatPassword = 'nopassword';
				self.step = 4;
			} else {
				self.step = 3;
			}

			self.ngxLoader.stop();
		}).catch(function (response) {
			self.ngxLoader.stop();
			if (response['error']['code'] === 'INVALID_EMAIL') {
				self.errormessage = "Er is een ongeldig e-mailadres ingevuld";
			} else if (response['error']['code'] === 'INVALID_EMAIL_EXTENSION_NOT_ALLOWED') {
				self.errormessage = "E-mail adres heeft een ongeldig domein. Controleer of je e-mailadres eindigt op .com of .nl";
			} else if (response['error']['code'] === 'EMAIL_ALREADY_EXISTS') {
				let message = self.dom.bypassSecurityTrustHtml("Er is al een gebruiker met dit e-mailadres geregistreerd. <a href=\"/wachtwoord-vergeten\">Wachtwoord vergeten?</a>");
				self.errormessage = message;
			} else {
				self.errormessage = "Er is een fout opgetreden";
			}
		});
	}

	checkStep3() {
		let self = this;
		self.errormessage = false;

		this.ngxLoader.start();
		self.api.save('users/checkPassword', { password: self.password, repeatPassword: self.repeatPassword }).then(function (response) {
			self.step = 4;
			self.ngxLoader.stop();
		}).catch(function (response) {
			self.ngxLoader.stop();
			if (response['error']['code'] === 'PASSWORD_INVALID') {
				self.errormessage = "Er is een ongeldig wachtwoord ingevuld.";
			} else if (response['error']['code'] === 'PASSWORDS_DO_NOT_MATCH') {
				self.errormessage = "Wachtwoorden komen niet overeen";
			} else {
				self.errormessage = "Er is een fout opgetreden";
			}
		});
	}

	save() {
		let self = this;
		self.errors = [];
		self.successmessage = false;
		self.errormessage = false;

		this.ngxLoader.start();
		this.api.save('users/register', {
			accessCode: self.classroomCode,
			password: btoa(self.password),
			repeatPassword: btoa(self.repeatPassword),
			name: self.name,
			email: self.email,
			registerHash: self.registerHash,
			encoding: 'base64'
		}).then((response) => {
			self.step = 5;
			self.ngxLoader.stop();
			setTimeout(function () {
				self.ngxLoader.start();
				self.authenticationService.authenticate(self.email, response['password']).then(function (response) {
					window.location.hash = '';
					window.location.reload();
				}).catch(function (error) {
					self.error = true;
					self.ngxLoader.stop();
				});
			}, 3000);
		}).catch(function (response) {
			self.ngxLoader.stop();
			self.errormessage = response['error']['message'];
			for (let error in response['error']['errors']) {
				self.errors[error] = response['error']['errors'][error];
			}
		});
	}

	resetValidation() {
		this.error = false;
		this.errorEmailRequired = false;
		this.errorInvalidEmail = false;
		this.errorInvalidEmailTld = false;
		this.errorPasswordRequired = false;
		this.emailValid = false;
		this.passwordValid = false;
	}

	close() {
		this.activeModal.close(false);
	}

	checkEmail(event) {
		this.errorEmailRequired = false;
		this.errorInvalidEmail = false;
		this.errorInvalidEmailTld = false;

		this.email = (this.email).replace(/\s/g, '');

		if (this.email.length < 6 || !this.email.includes('@') || !this.email.includes('.')) {
			this.errorEmailRequired = false;
			this.errorInvalidEmail = true;
		} else if (this.validateEmail(this.email) === false) {
			this.errorInvalidEmail = true;
		} else if (this.validateTld(this.email) === false) {
			this.errorInvalidEmail = true;
		} else {
			this.emailValid = true;
		}
	}

	checkRepeatPassword(event) {
		if ((this.repeatPassword.length + 2) > this.password.length && this.repeatPassword != this.password) {
			this.repeatPasswordInvalid = true;
			this.repeatPasswordValid = false;
		} else if (this.repeatPassword == this.password) {
			this.repeatPasswordInvalid = false;
			this.repeatPasswordValid = true;
		} else {
			this.repeatPasswordInvalid = false;
			this.repeatPasswordValid = false;
		}
	}

	setClassroomCode() {
		this.classroomCode = '';
		this.classroomCode += this.classroomCode1;
		this.classroomCode += this.classroomCode2;
		this.classroomCode += this.classroomCode3;
		this.classroomCode += this.classroomCode4;
		this.classroomCode += this.classroomCode5;
		this.classroomCode += this.classroomCode6;
		this.classroomCode += this.classroomCode7;
		this.classroomCode += this.classroomCode8;
	}

	onCodePaste(event) {
		let clipboardData = event.clipboardData;
		let pastedText = clipboardData.getData('text');
		if (pastedText) {
			this.classroomCode1 = pastedText.slice(0, 1);
			this.classroomCode2 = pastedText.slice(1, 2);
			this.classroomCode3 = pastedText.slice(2, 3);
			this.classroomCode4 = pastedText.slice(3, 4);
			this.classroomCode5 = pastedText.slice(4, 5);
			this.classroomCode6 = pastedText.slice(5, 6);
			this.classroomCode7 = pastedText.slice(6, 7);
			this.classroomCode8 = pastedText.slice(7, 8);
			setTimeout(function () {
				(<HTMLInputElement>document.getElementById("classroom-code-8")).focus();
				(<HTMLInputElement>document.getElementById("classroom-code-8")).blur();
			}, 200);
			this.setClassroomCode();
		}
	}

	checkCodeInput(event) {
		let input = String.fromCharCode(event.keyCode);
		let sourceElement = event.target;

		if (input == '8' || input == '46') {
			let nextElement = sourceElement.nextSibling;
			return;
		}

		if (/[a-zA-Z0-9]/.test(input)) {
			this[sourceElement['id']] = sourceElement['value'];
			let nextElement = sourceElement.nextSibling;
			if (nextElement) {
				nextElement.focus();
			}
		} else {
			this[sourceElement['id']] = sourceElement['value'];
		}
		this.setClassroomCode();
	}
}
